import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class IsEqualToRule implements IValidationRule
{
    public rule: RuleName = 'IsEqualTo';
    private getValueToCompare: () => string;
    private errorLabel: string;

    constructor(getValueToCompare: () => string, validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.getValueToCompare = getValueToCompare;
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.mustBeEqualToLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        const valueToCompare = this.getValueToCompare();
        if (value == valueToCompare)
        {
            return '';
        }
        return this.errorLabel;
    }
}
